import { Text, Title } from '@mantine/core'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary'

import type { SessionState } from '~/Auth'

export interface RouterContext {
  isAuthenticated: boolean
  session: SessionState
}

function ErrorFallback({ error }: FallbackProps) {
  const message = error instanceof Error ? error.message : String(error)
  return (
    <div style={{ padding: '2rem' }}>
      <Title order={2}>Something went wrong</Title>
      <Text c="dimmed" mt="sm">
        {message}
      </Text>
    </div>
  )
}

function RootLayout() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Outlet />
    </ErrorBoundary>
  )
}

export const Route = createRootRouteWithContext<RouterContext>()({ component: RootLayout })
